import React, {} from "react"

// Pure function: returns a currency code string based on browser timezone.
// Used by resolveCurrency.js as the geo-detection fallback.
export function detectCurrencyFromTimezone() {
   let currency = 'GBP';
   try {
      let location = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (location.indexOf('Europe') > -1) {
         location.indexOf('London') > -1 ? currency = 'GBP' : location.indexOf('Stockholm') > -1 ? currency = 'SEK' : currency = 'EUR';
      } else if (
         (location.indexOf('America/Creston') > -1)
         || (location.indexOf('America/Vancouver') > -1)
         || (location.indexOf('America/Whitehorse') > -1)
         || (location.indexOf('America/Cambridge_Bay') > -1)
         || (location.indexOf('America/Edmonton') > -1)
         || (location.indexOf('America/Inuvik') > -1)
         || (location.indexOf('America/Regina') > -1)
         || (location.indexOf('America/Swift_Current') > -1)
         || (location.indexOf('America/Yellowknife') > -1)
         || (location.indexOf('America/Coral_Harbour') > -1)
         || (location.indexOf('America/Dawson_Creek') > -1)
         || (location.indexOf('America/Rainy_River') > -1)
         || (location.indexOf('America/Rankin_Inlet') > -1)
         || (location.indexOf('America/Resolute') > -1)
         || (location.indexOf('America/Winnipeg') > -1)
         || (location.indexOf('America/Blanc-Sablon') > -1)
         || (location.indexOf('America/Iqaluit') > -1)
         || (location.indexOf('America/Montreal') > -1)
         || (location.indexOf('America/Nipigon') > -1)
         || (location.indexOf('America/Pangnirtung') > -1)
         || (location.indexOf('America/Thunder_Bay') > -1)
         || (location.indexOf('America/Toronto') > -1)
         || (location.indexOf('America/Glace_Bay') > -1)
         || (location.indexOf('America/Goose_Bay') > -1)
         || (location.indexOf('America/Halifax') > -1)
         || (location.indexOf('America/Moncton') > -1)
         || (location.indexOf('America/St_Johns') > -1)
      ) {
         currency = 'CAD';
      } else if (location.indexOf('America') > -1) {
         currency = 'USD';
      } else if (location.indexOf('Africa') > -1) {
         currency = 'USD';
      } else if (
         (location.indexOf('Australia') > -1)
         || (location.indexOf('Indian/Cocos') > -1)
         || (location.indexOf('Indian/Christmas') > -1)
      ) {
         currency = 'AUD';
      } else if (
         (location.indexOf('Pacific/Auckland') > -1)
         || (location.indexOf('Pacific/Chatham') > -1)
      ) {
         currency = 'NZD';
      } else {
         currency = 'USD';
      }
   } catch {
      currency = 'GBP';
   }
   return currency;
}

export default function getGeoInfo(return_val=false, return_only=false) {
   // axios.get('https://ipapi.co/json/').then((response) => {
   //    let data = response.data;
   //    let currency = ''
   //    if (data.country_name == 'United States'){
   //    currency = 'USD'
   //    } else if (european_countries.indexOf(data.country_name) > -1) {
   //    currency = 'EUR'
   //    } else {
   //    currency = 'GBP'
   //    }
   //    this.setState({
   //       countryName: data.country_name,
   //       currency: currency,
   //    });
   //    if (return_val){
   //       return currency
      
   //    }
   // }).catch((error) => {
   //     console.log(error);
   // });
   let currency = 'GBP'
   try {
      let location = Intl.DateTimeFormat().resolvedOptions().timeZone
      // let locale = Intl.NumberFormat().resolvedOptions().locale
      if (location.indexOf('Europe') > -1) {
         location.indexOf('London') > -1 ? currency = 'GBP' : location.indexOf('Stockholm') > -1 ? currency = 'SEK' :  currency = 'EUR'
      } else if (
         (location.indexOf('America/Creston') > -1)
         || (location.indexOf('America/Vancouver') > -1)
         || (location.indexOf('America/Whitehorse') > -1)
         || (location.indexOf('America/Cambridge_Bay') > -1)
         || (location.indexOf('America/Edmonton') > -1)
         || (location.indexOf('America/Inuvik') > -1)
         || (location.indexOf('America/Regina') > -1)
         || (location.indexOf('America/Swift_Current') > -1)
         || (location.indexOf('America/Yellowknife') > -1)
         || (location.indexOf('America/Coral_Harbour') > -1)
         || (location.indexOf('America/Dawson_Creek') > -1)
         || (location.indexOf('America/Rainy_River') > -1)
         || (location.indexOf('America/Rankin_Inlet') > -1)
         || (location.indexOf('America/Resolute') > -1)
         || (location.indexOf('America/Winnipeg') > -1)
         || (location.indexOf('America/Blanc-Sablon') > -1)
         || (location.indexOf('America/Iqaluit') > -1)
         || (location.indexOf('America/Montreal') > -1)
         || (location.indexOf('America/Nipigon') > -1)
         || (location.indexOf('America/Pangnirtung') > -1)
         || (location.indexOf('America/Thunder_Bay') > -1)
         || (location.indexOf('America/Toronto') > -1)
         || (location.indexOf('America/Glace_Bay') > -1)
         || (location.indexOf('America/Goose_Bay') > -1)
         || (location.indexOf('America/Halifax') > -1)
         || (location.indexOf('America/Moncton') > -1)
         || (location.indexOf('America/St_Johns') > -1)
      ) {
         currency = 'CAD'
      } else if (location.indexOf('America') > -1) {
         currency = 'USD'
      } else if (location.indexOf('Africa') > -1) {
         currency = 'USD'
      } else if (
         (location.indexOf('Australia') > -1)
         || (location.indexOf('Indian/Cocos') > -1)	
         || (location.indexOf('Indian/Christmas') > -1)	
      ) {
         currency = 'AUD'
      } else if (
         (location.indexOf('Pacific/Auckland') > -1)
         || (location.indexOf('Pacific/Chatham') > -1)	
      ) {
         currency = 'NZD'
      } else {
         currency = 'USD'
      }
      if (return_only === false){
         this.setState({currency: currency})
      }
      if (return_val) {
         return currency
      }
   }
   catch {
      if (return_only === false){
         this.setState({currency: 'GBP'})
      }
      if (return_val) {
         return 'GBP'
      }
   }
};
